var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeadlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.7434L12.6341 11.6139H2.36591L7.5 2.7434ZM7.5 0.0229492L0 12.9775H15L7.5 0.0229492Z",
    fill: "#FFA726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 9.5684H6.81818V10.932H8.18182V9.5684Z",
    fill: "#FFA726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 5.47749H6.81818V8.88659H8.18182V5.47749Z",
    fill: "#FFA726"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlineIcon);
export default __webpack_public_path__ + "static/media/deadlineIcon.266abf3f8ae97c79df6debcb19298ace.svg";
export { ForwardRef as ReactComponent };